var map = {
	"./X33-Mall_small.jpg": 905,
	"./all-active.svg": 906,
	"./all.svg": 907,
	"./apple-watch.png": 908,
	"./b-headphone.png": 909,
	"./coin.svg": 910,
	"./delete-btn.svg": 911,
	"./iphone-pink.png": 912,
	"./love-active.svg": 913,
	"./love.svg": 914,
	"./mobile-bg.jpg": 915,
	"./price-high-active.svg": 916,
	"./price-high.svg": 917,
	"./price-low-active.svg": 918,
	"./price-low.svg": 919,
	"./shopping-cart.svg": 920,
	"./star.svg": 921,
	"./x33mall-banner-cn.jpg": 922,
	"./x33mall-banner-id.jpg": 923,
	"./x33mall-banner-ms.jpg": 924,
	"./x33mall-banner.jpg": 925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;